export const CHART_SUPPORT_THRESHOLD = '2026-04-10'
